import React from 'react';
import ImageEditor from '../imageeditor/ImageEditor';
import PropTypes from 'prop-types';

const ImageField = ({
  form,
  field,
  imageDataUrl = undefined,
  imageUrl = undefined,
  scaleImage = false,
  width = 300,
  height = 300,
  maxWidth,
  maxHeight,
  clearFormFields = [],
  setProductImage = () => {},
}) => {
  const handleDataUrlUpdate = dataURL => {
    form.setFieldValue(field.name, dataURL);
    setProductImage(dataURL);
  };

  const handleImageClear = () => {
    clearFormFields.forEach(fieldName => {
      setProductImage('');
      form.setFieldValue(fieldName, '');
    });
  };

  return (
    <ImageEditor
      imageDataUrl={imageDataUrl}
      imageUrl={imageUrl}
      enableScale={scaleImage}
      onDataUrlUpdate={handleDataUrlUpdate}
      onImageClear={handleImageClear}
      imageWidth={width}
      imageHeight={height}
      displayWidth={maxWidth}
      displayHeight={maxHeight}
      setProductImage={setProductImage}
    />
  );
};

ImageField.propTypes = {
  imageDataUrl: PropTypes.string,
  imageUrl: PropTypes.string,
  scaleImage: PropTypes.bool,
  width: PropTypes.number,
  height: PropTypes.number,
  maxWidth: PropTypes.number,
  maxHeight: PropTypes.number,
  clearFormFields: PropTypes.array,
};

export default ImageField;
